/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'external-link': {
    width: 1,
    height: 1,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="none" _stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M15 11v4H1V1h4"/><path pid="1" _fill="currentColor" d="M16 0v7l-2.5-2.5L8 10 6 8l5.5-5.5L9 0h7z"/>'
  }
})
